import {
	memo, PropsWithChildren,
} from 'react';
import styled, { css } from 'styled-components';

import Theme from '../../styles/Theme';
import { MarqueeWrapper } from '../common/MarqueeWrapper';

import { IconChevronLeft } from '../icon/IconChevronLeft';

interface Props {
	title?: string;
	subTitle?: string | null;

	titleBelowSubTitle?: boolean;

	onBack: () => void;
}

const StyledHeader = styled.header`
	background: ${(props) => props.theme.white};
	border-bottom: 1px solid ${(props) => props.theme.borderColor};
	position: relative;

	padding: ${(props) => 20 / props.theme.fontSizeBase}rem 0 ${(props) => 12 / props.theme.fontSizeBase}rem 0;
`;

const StyledIconChevronLeft = styled(IconChevronLeft)`
	position: absolute;
	top: ${(props) => 26 / props.theme.fontSizeBase}rem;
	left: ${(props) => 24 / props.theme.fontSizeBase}rem;
	cursor: pointer;
`;

const StyledTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1;
	margin-bottom: ${(props) => 8 / props.theme.fontSizeBase}rem;
`;

const StyledTitle = styled.span<{margin: boolean}>`
	font-family: 'Plus Jakarta Sans',sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: ${(props) => 16 / props.theme.fontSizeBase}rem;
	line-height: ${(props) => 20 / props.theme.fontSizeBase}rem;
	color: ${(props) => props.theme.black};

	${(props) => props.margin && css`
		margin-right: ${1 / props.theme.fontSizeBase}rem;
	`};
`;

const StyledSubTitle = styled.span`
	font-family: 'Plus Jakarta Sans',sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: ${(props) => 13 / props.theme.fontSizeBase}rem;
	line-height: ${(props) => 16 / props.theme.fontSizeBase}rem;
	color: ${(props) => props.theme.black};
	opacity: 0.4;
`;

const StyledMarqueeContainer = styled.div`
	width: 70%;
	margin: auto;
`;

// eslint-disable-next-line react/display-name
export const MapHeaderBackButton = memo(({
	title, subTitle, onBack, titleBelowSubTitle = false, children,
}: PropsWithChildren<Props>) => (
	<StyledHeader>
		<StyledIconChevronLeft width={24} height={24} color={Theme.black} onClick={onBack} />
		<StyledTitleContainer>
			{ titleBelowSubTitle && <>
				{ subTitle && <StyledSubTitle>{ subTitle }</StyledSubTitle> }
				{ title && <StyledMarqueeContainer>
					<MarqueeWrapper>
						<StyledTitle margin={true}>{ title }</StyledTitle>
					</MarqueeWrapper>
				</StyledMarqueeContainer> }
			</>}

			{ !titleBelowSubTitle && <>
				{ title && <StyledTitle margin={false}>{ title }</StyledTitle> }
				{ subTitle && <StyledSubTitle>{ subTitle }</StyledSubTitle> }
			</>}

		</StyledTitleContainer>

		{ children }
	</StyledHeader>
));
